<script setup>
/* global axios */
// Seletor de PARTICIPANTES do grupo (WhatsApp/AstraCall), aberto pelo gatilho "@@"
// no compositor de RESPOSTA. Não mexe no "@" de agentes (que só abre em nota privada).
// Ao escolher, o Editor insere "@<número> " — que o bridge do AstraCalls transforma
// em menção real (contextInfo.mentionedJid).
import { ref, computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import CaretAnchoredPicker from 'dashboard/components-next/preview-picker/CaretAnchoredPicker.vue';

const props = defineProps({
  caretPosition: { type: Object, default: null },
  searchKey: { type: String, default: '' },
  conversationId: { type: [Number, String], default: null },
});
const emit = defineEmits(['selectParticipant', 'close', 'removeTrigger']);

const route = useRoute();
const participants = ref([]);
const searchQuery = ref(props.searchKey);
watch(
  () => props.searchKey,
  v => {
    searchQuery.value = v;
  }
);

const fmtPhone = v => {
  const d = String(v || '')
    .replace(/@.*/, '')
    .replace(/\D/g, '');
  return d ? `+${d}` : v;
};

const load = async () => {
  if (!props.conversationId) return;
  try {
    const { data } = await axios.get(
      `/api/v1/accounts/${route.params.accountId}/kanban/connections/group_participants`,
      { params: { conversation_id: props.conversationId } }
    );
    participants.value = Array.isArray(data.data) ? data.data : [];
  } catch (e) {
    participants.value = [];
  }
};
onMounted(load);
watch(() => props.conversationId, load);

const term = computed(() => searchQuery.value.trim().toLowerCase());
const items = computed(() =>
  participants.value
    // só quem tem NÚMERO é mencionável (nome sem número vem só do prefixo da msg;
    // o número p/ marcar de verdade vem do sync do provedor).
    .filter(p => p.number)
    .filter(p => {
      if (!term.value) return true;
      return (
        (p.name || '').toLowerCase().includes(term.value) ||
        (p.number || '').includes(term.value)
      );
    })
    .map(p => ({
      id: p.jid || p.number,
      record: p,
      label: p.name || fmtPhone(p.number),
      title: p.name || fmtPhone(p.number),
      subtitle: p.name ? fmtPhone(p.number) : '',
    }))
);

const initial = label => (label || '?').trim().charAt(0).toUpperCase();
const onSelect = item => emit('selectParticipant', item.record);
</script>

<template>
  <CaretAnchoredPicker
    v-model:search="searchQuery"
    :caret-position="caretPosition"
    :items="items"
    search-placeholder="Buscar participante…"
    empty-label="Nenhum participante encontrado"
    @select="onSelect"
    @close="emit('close')"
    @remove-trigger="emit('removeTrigger')"
  >
    <template #leading="{ item }">
      <span
        class="flex items-center justify-center text-[10px] font-medium text-white rounded-full size-6 shrink-0 bg-n-blue-9"
      >
        {{ initial(item.label) }}
      </span>
    </template>
  </CaretAnchoredPicker>
</template>
